<template>
  <v-dialog v-model="dialog" width="580px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM ĐIỂM DỪNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <div class="pa-6">
        <div class="font-weight-bold">
          {{ busSchedule.dayOfWeek | scheduleDay }} -
          {{ busTimelines[busSchedule.index] ? busTimelines[busSchedule.index].title : '' }}
        </div>
        <BusStopForm class="mt-6" ref="form" />
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BusStopForm from '@/components/basic/form/bus/BusStopForm.vue'
import { BusStop } from '../../plugins/api'

export default {
  components: {
    BusStopForm,
  },
  props: {
    state: Boolean,
    busSchedule: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines']),
    ...mapState('busDetail', ['busData']),
  },

  methods: {
    ...mapActions('busDetail', ['createBusStop']),
    async save() {
      this.$refs.form.setIsRule(true)
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      try {
        const formData = this.$refs.form.getData()
        const param = {
          bus: this.busData.id,
          address: formData.address,
          busSchedule: this.busSchedule.id,
        }
        const duplicateBusStops = await BusStop.fetch(param)
        if (duplicateBusStops && duplicateBusStops.length) {
          const duplicateBS = duplicateBusStops.find(
            (bs) => bs.address.toLowerCase() === formData.address.toLowerCase()
          )
          if (duplicateBS && duplicateBS.id) {
            this.$alert.error('Tên đã tồn tại')
            return
          }
        }
        const busStopData = {
          bus: this.busData.id,
          address: formData.address,
          busSchedule: this.busSchedule.id,
          timeIn: formData.timeIn,
          timeOut: formData.timeOut,
        }
        await this.createBusStop({ data: busStopData, week: formData.week })
        this.$refs.form.resetDefault()
        this.$refs.form.resetValidation()
        this.dialog = false
      } catch (error) {
        this.$alert.addError(error)
      } finally {
        this.$loading.active = false
      }
      this.$refs.form.resetValidation()
    },
    cancel() {
      this.$refs.form.resetDefault()
      this.$refs.form.resetValidation()
      this.dialog = false
    },
  },

  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>
